import type { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const ServicesPage = lazy(() => import("../pages/services/page"));
const MembershipPage = lazy(() => import("../pages/membership/page"));
const MembershipCheckoutPage = lazy(() => import("../pages/membership/checkout/page"));
const CartPage = lazy(() => import("../pages/cart/page"));
const AccountPage = lazy(() => import("../pages/account/page"));
const LoginPage = lazy(() => import("../pages/auth/login"));
const OrderConfirmationPage = lazy(() => import("../pages/order-confirmation/page"));
const PartnershipPage = lazy(() => import("../pages/partnership/page"));
const FlexibilniVyzvedavaniPage = lazy(() => import("../pages/flexibilni-vyzvedavani/page"));
const ObchodniPodminkyPage = lazy(() => import("../pages/obchodni-podminky/page"));
const StornoPodminkyPage = lazy(() => import("../pages/storno-podminky/page"));
const ZpracovaniOsobnichUdajuPage = lazy(() => import("../pages/zpracovani-osobnich-udaju/page"));
const ONasPage = lazy(() => import("../pages/o-nas/page"));
const AffiliatePage = lazy(() => import("../pages/affiliate/page"));
const AffiliateLoginPage = lazy(() => import("../pages/affiliate/login"));
const AffiliateDashboardPage = lazy(() => import("../pages/affiliate/dashboard/page"));
const AffiliateInfoPage = lazy(() => import("../pages/affiliate-info/page"));
const AffiliateVideoPage = lazy(() => import("../pages/affiliate-video/page"));
const AdminPage = lazy(() => import("../pages/admin/page"));
const AdminMembershipsPage = lazy(() => import("../pages/admin/memberships/page"));
const AdminOrderNotificationsPage = lazy(() => import("../pages/admin/order-notifications/page"));
const AdminTestOrderPage = lazy(() => import("../pages/admin/test-order/page"));
const AdminTestEmailPage = lazy(() => import("../pages/admin/test-email/page"));
const AdminTestMembershipPage = lazy(() => import("../pages/admin/test-membership/page"));
const AdminTestDashboardPage = lazy(() => import("../pages/admin/test-dashboard/page"));
const AdminTestActivationPage = lazy(() => import("../pages/admin/test-activation/page"));
const AdminDnsHelpPage = lazy(() => import("../pages/admin/dns-help/page"));
const AdminCreateTestAuthPage = lazy(() => import("../pages/admin/create-test-auth/page"));
const ClenskaZonaPage = lazy(() => import("../pages/clenska-zona/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));
const TestEmailSendPage = lazy(() => import("../pages/test-email-send/page"));

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/sluzby", element: <ServicesPage /> },
  { path: "/clenstvi", element: <MembershipPage /> },
  { path: "/clenstvi/pokladna", element: <MembershipCheckoutPage /> },
  { path: "/clenstvi/objednavka", element: <MembershipCheckoutPage /> },
  { path: "/membership/checkout", element: <MembershipCheckoutPage /> },
  { path: "/kosik", element: <CartPage /> },
  { path: "/muj-ucet", element: <AccountPage /> },
  { path: "/prihlaseni", element: <LoginPage /> },
  { path: "/auth/login", element: <LoginPage /> },
  { path: "/objednavka-potvrzena", element: <OrderConfirmationPage /> },
  { path: "/partner", element: <PartnershipPage /> },
  { path: "/flexibilni-vyzvedavani", element: <FlexibilniVyzvedavaniPage /> },
  { path: "/obchodni-podminky", element: <ObchodniPodminkyPage /> },
  { path: "/storno-podminky", element: <StornoPodminkyPage /> },
  { path: "/zpracovani-osobnich-udaju", element: <ZpracovaniOsobnichUdajuPage /> },
  { path: "/o-nas", element: <ONasPage /> },
  { path: "/affiliate", element: <AffiliatePage /> },
  { path: "/affiliate/login", element: <AffiliateLoginPage /> },
  { path: "/affiliate/dashboard", element: <AffiliateDashboardPage /> },
  { path: "/affiliate-info", element: <AffiliateInfoPage /> },
  { path: "/affiliate-video", element: <AffiliateVideoPage /> },
  { path: "/admin", element: <AdminPage /> },
  { path: "/admin/memberships", element: <AdminMembershipsPage /> },
  { path: "/admin/order-notifications", element: <AdminOrderNotificationsPage /> },
  { path: "/admin/test-order", element: <AdminTestOrderPage /> },
  { path: "/admin/test-email", element: <AdminTestEmailPage /> },
  { path: "/admin/test-membership", element: <AdminTestMembershipPage /> },
  { path: "/admin/test-dashboard", element: <AdminTestDashboardPage /> },
  { path: "/admin/test-activation", element: <AdminTestActivationPage /> },
  { path: "/admin/dns-help", element: <AdminDnsHelpPage /> },
  { path: "/admin/create-test-auth", element: <AdminCreateTestAuthPage /> },
  { path: "/clenska-zona", element: <ClenskaZonaPage /> },
  { path: "*", element: <NotFoundPage /> },
  {
    path: "/test-email-send",
    element: <TestEmailSendPage />,
  },
];

export default routes;
